import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapSingle } from '../ruutsApi/normalize'

const namespace = 'rpd'

const readFileAsDataURL = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })

// The v1 handler expects a JSON body carrying a base64 data URL, not multipart.
const uploadFile = async ({ dir, file }: { dir: string; file: File }) => {
  const response = await apiClient.post(
    `${endpoints.objectStore}/${namespace}/${encodeURIComponent(dir)}/${encodeURIComponent(file.name)}`,
    { file: await readFileAsDataURL(file) },
  )
  return unwrapSingle<{ url: string }>(response).url
}

export const uploadFiles = ({ dir, files }: { dir: string; files: File[] }) =>
  Promise.all(files.map(file => uploadFile({ dir, file })))
